import { render, staticRenderFns } from "./U3Video.vue?vue&type=template&id=6db0e7cb&"
import script from "./U3Video.vue?vue&type=script&lang=js&"
export * from "./U3Video.vue?vue&type=script&lang=js&"
import style0 from "./U3Video.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/frameto/WebSites/U3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6db0e7cb', component.options)
    } else {
      api.reload('6db0e7cb', component.options)
    }
    module.hot.accept("./U3Video.vue?vue&type=template&id=6db0e7cb&", function () {
      api.rerender('6db0e7cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/U3Video.vue"
export default component.exports